













































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Home extends Vue {
  mounted() {
    if (process.env.NODE_ENV !== 'production') {
      const versionInfo = `
        env: ${process.env.NODE_ENV} <br/>
        hash: ${process.env.VUE_APP_GIT_HASH} <br/>
        timestamp: ${process.env.VUE_APP_BUILD_TIMESTAMP}
    `;
      this.$buefy.toast.open({
        message: versionInfo,
        duration: 5000
      });
    }
  }
}
